export const SubDomainRegex = new RegExp(/(?!.*[-]{2,})(?![0-9]+$)(?![-]+)(?!.*[-]+$)^[a-z0-9-]{2,63}$/);
export const FullNameRegex = new RegExp(/^[a-z]([-']?[a-z]+)*([.])?( [a-z]([-']?[a-z]+)*([.])?)+$/i);
export const MobileNumberRegex = new RegExp(/^(\+)?([ 0-9()-]){7,16}$/);
export const ZipCodeRegex = new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/);
